import React, { useState, useEffect, useRef } from 'react';
import { TextField, Box, List, ListItem, Paper } from '@mui/material';
import { CityDataNew } from '../data/cities';

const CityDropdown = ({ value, onChange, error, helperText }) => {
  const [searchTerm, setSearchTerm] = useState(value || '');
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSearchTerm(value || '');
  }, [value]);

  useEffect(() => {
    const filtered = CityDataNew.filter(city =>
      city.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCities(filtered);
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
    onChange(e);
  };

  const handleCitySelect = (city) => {
    onChange({ target: { name: 'City', value: city } });
    setSearchTerm(city);
    setShowDropdown(false);
  };

  return (
    <Box ref={dropdownRef} sx={{ position: 'relative' }}>
      <TextField
        fullWidth
        label="City"
        name="City"
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={() => setShowDropdown(true)}
        error={error}
        helperText={helperText}
        required
      />
      {showDropdown && filteredCities.length > 0 && (
        <Paper
          elevation={3}
          sx={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto',
            mt: 1,
          }}
        >
          <List>
            {filteredCities.map((city, index) => (
              <ListItem
                key={index}
                onClick={() => handleCitySelect(city)}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                {city}
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
};

export default CityDropdown; 